<button
    #triggerButton
    [attr.id]="id.button"
    [matTooltip]="tooltipText"
    [matTooltipShowDelay]="500"
    [matTooltipDisabled]="open"
    [ngClass]="
        {
            'tt-overflow-menu__button--open': !ttType && open,
            'tt-overflow-menu__button': !ttType,
            'tt-button--primary': ttType === 'primary',
            'tt-button--secondary': ttType === 'secondary',
            'tt-button--success': ttType === 'success',
            'tt-button--danger': ttType === 'danger',
            'tt-button--warning': ttType === 'warning',
        } +
        ' ' +
        ttClasses
    "
    class="tt-button tt-overflow-menu__trigger"
    (click)="toggleMenu()"
    aria-label="Menu"
    aria-haspopup="menu"
    ttOutsideClick
    [ignore]="id.menu"
    (onOutsideClick)="closeMenu()"
    [attr.aria-expanded]="open"
>
    <span *ngIf="!!text" class="tt-overflow-menu__text">{{ text }}</span>
    <span class="fa-fw far" [ngClass]="ttIcon ? ttIcon : 'fa-ellipsis-v'"></span>
</button>
<ul #menu *ngIf="open" [attr.id]="id.menu" class="tt-overflow__menu" [ngClass]="ttMenuClasses" (click)="onMenuClick($event)">
    <ng-content></ng-content>
</ul>
